import { WidgetMaker } from '../types/widget-maker';
import { defaultFontFamily } from './default-font-family';
import { defaultFontSize } from './default-font-size';
import { defaultLineHeight } from './default-line-height';
import { defaultTextAlign } from './default-text-align';

export const defaultWidgetMakerConfig: WidgetMaker = {
  font: defaultFontFamily,
  fontSize: '12px',
  width: 500,
  numberOfRows: 2,
  itemsPerRow: 4,
  textColor: 'black',
  textBackgroundColor: 'white',
  fields: [
    { data: 'description', extraText: '' },
    { data: 'price', extraText: '' },
  ],
  title: 'Recommended for you',
  CTAButtonText: 'Shop Now',
  header: {
    active: false,
    text: 'Recommended for you',
    fontFamily: defaultFontFamily,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: 16,
    lineHeight: defaultLineHeight,
    letterSpacing: 0,
    textColor: 'black',
    textAlign: 'center',
    textDecoration: 'none',
  },
  productCard: [
    {
      field: 'title',
      text: '',
      position: 0,
      fontFamily: defaultFontFamily,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontSize: defaultFontSize,
      lineHeight: defaultLineHeight,
      letterSpacing: 0,
      textColor: 'black',
      textAlign: defaultTextAlign,
      textDecoration: 'none',
    },
    {
      field: 'price',
      text: '',
      position: 1,
      fontFamily: defaultFontFamily,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontSize: defaultFontSize,
      lineHeight: defaultLineHeight,
      letterSpacing: 0,
      textColor: 'black',
      textAlign: defaultTextAlign,
      textDecoration: 'none',
    },
  ],
  CTAButton: {
    active: false,
    text: 'Shop Now',
    fontFamily: defaultFontFamily,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontSize: defaultFontSize,
    lineHeight: defaultLineHeight,
    letterSpacing: 0,
    textColor: 'white',
    textAlign: 'center',
    textDecoration: 'none',
    backgroundColor: 'black',
    borderRadius: 0,
    borderWidth: 0,
    borderStyle: 'none',
    borderColor: 'black',
  },
};
